import React, { useEffect, useRef } from "react";
import { addToCart, removeFromCart } from "../actions/cartAction";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Stepper from "../components/Stepper";
import { useState } from "react";
import {motion} from 'framer-motion'
import lottie from 'lottie-web'

import { createOrder } from "../actions/orderAction";

import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import ReactSwipeButton from "react-swipe-button";
import TextField from "@material-ui/core/TextField";
import ModalConfirmed from '../components/ModalConfirmed';

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker
} from "@material-ui/pickers";

const useStyles = makeStyles(theme => ({
  input: {
    width: "100%",
    height: "4rem"
  },
  quantity: {
    fontSize: "15px",
    color: "black"
  },
  area: {
    width: "100%",
    paddingTop: "2rem"
  }
}));

function PlaceOrderScreen(props) {
  const classes = useStyles();
  const container = useRef(null)

  const [newOrder, setNewOrder] = useState(true);
  const [date, setDate] = useState(new Date());
  const [notes,setNotes] = useState('');
  const [showSuccess,setShowSuccess] = useState(false);


  const cart = useSelector(state => state.cart);
  const orderCreate = useSelector(state => state.orderCreate);
  const { loading, success, error, order } = orderCreate;
  const { cartItems, shipping, payment } = cart;

  if (!shipping) {
    props.history.push("/shipping");
  }
  if (!payment) {
    console.log(shipping);

    props.history.push("/payment");
  }

  let districtPrices = new Map();
  districtPrices.set("Paramaribo", 5);
  districtPrices.set("Wanica", 5);
  districtPrices.set("Nickerie", 10);
  districtPrices.set("Para", 10);

  const getShippingPrice = district => {
    return districtPrices.get(district);
  };

  const pickUp = cart.shipping.pickUp;
  const itemPrice = cartItems
    .reduce((a, c) => a + c.price * c.qty, 0)
    .toFixed(2);
  const shippingPrice =
    pickUp === false
      ? cart.shipping && getShippingPrice(cart.shipping.district)
      : 0;
  const taxPrice = 0;//Number((0.15 * itemPrice).toFixed(2));
  const totalPrice = (Number(itemPrice) + shippingPrice + taxPrice).toFixed(2);
  const dispatch = useDispatch();

  const handleDate = date => {
    setDate(date);
    console.log(date);
  };

  const placeOrderHandler = () => {
    dispatch(
      createOrder({
        orderItems: cartItems,
        shipping,
        payment,
        itemPrice,
        shippingPrice,
        taxPrice,
        totalPrice,
        pickUp,
        notes,
        date
      })
    );
    setNewOrder(false);
    setShowSuccess(true);
  };

  const checkoutHandler = () => {
    props.history.push("/signin?redirect=shipping");
  };

  useEffect(() => {
    lottie.loadAnimation({
      container:container.current,
      renderer:'svg',
      loop:false,
      autoplay:true,
      animationData:{"v":"5.6.1","fr":60,"ip":0,"op":93,"w":90,"h":90,"nm":"Cashback Activation Animation","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"check","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[46,46,0],"ix":2},"a":{"a":0,"k":[-64.139,-543.26,0],"ix":1},"s":{"a":0,"k":[39.706,39.706,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.841,0.133],[-0.919,-0.115]],"o":[[0,0],[0.059,0.133],[-1.115,-0.102]],"v":[[-24.839,-568.19],[-76.231,-518.331],[-103.417,-545.583]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":62,"s":[0],"e":[100]},{"t":63}],"ix":4},"w":{"a":0,"k":18,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.673],"y":[1]},"o":{"x":[0.34],"y":[0]},"t":62,"s":[0],"e":[100]},{"i":{"x":[0.477],"y":[0.892]},"o":{"x":[0.061],"y":[0]},"t":63,"s":[100],"e":[0]},{"t":88}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"gr","it":[{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":1,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":935,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"bg","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[16.233,24.733,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.385,0.385,0.663],"y":[0.996,0.996,-36.691]},"o":{"x":[0.369,0.369,0.296],"y":[0,0,0]},"t":47,"s":[0,0,100],"e":[156.367,156.367,100]},{"i":{"x":[0.558,0.558,0.812],"y":[1.011,1.011,1]},"o":{"x":[0.239,0.239,0.427],"y":[-0.017,-0.017,33.575]},"t":74,"s":[156.367,156.367,100],"e":[128.636,128.636,100]},{"t":93}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[15.317,0],[0,-15.317],[-15.317,0],[0,15.317]],"o":[[-15.317,0],[0,15.317],[15.317,0],[0,-15.317]],"v":[[0,-27.733],[-27.733,0],[0,27.733],[27.733,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.227450981736,0.878431379795,0.752941191196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[16.233,24.733],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":2400,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"progress","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[111.5,111.5,0],"ix":1},"s":{"a":0,"k":[47,47,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-46.392,0],[0,46.392],[46.392,0],[0,-46.392]],"o":[[46.392,0],[0,-46.392],[-46.392,0],[0,46.392]],"v":[[0,84],[84,0],[0,-84],[-84,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.098039217293,0.796078443527,0.662745118141,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":17,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[111.5,111.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.783],"y":[0]},"t":0,"s":[100],"e":[0]},{"t":53}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-34,"op":967,"st":180,"bm":0}],"markers":[]}
    })
    if (success && !newOrder) {
      setTimeout(()=>{
        props.history.push("/order/" + order.orderId);
      },1700)
    }
  }, [success]);
  return (
    <div className="screen-content">
      {/* <CheckoutSteps step1 step2 step3 step4></CheckoutSteps> */}
      {showSuccess && 
      <>
      <motion.div
      initial={{
        opacity:0
      }}
      animate={{
        opacity:1
      }}
      className='modal-backdrop'>
        <motion.div 
        initial={{
          scale:0
        }}
        animate={{
          scale:1
        }}
        className='modal-content-wrapper'>
          <motion.div className='modal-success-content'>
          <div ref={container}>
        </div>
          </motion.div>
        </motion.div>
      </motion.div>
      </>
      }
      <Stepper step="3"></Stepper>
      <div className="placeorder">
        <div className="placeorder-info">
          {cart.shipping.pickUp === false ? (
            <div className="box-shadow">
              <h3>Adres</h3>
              <div>
                {cart.shipping.address ? cart.shipping.address : ""},{" "}
                {cart.shipping.resort}, {cart.shipping.district},{" "}
                {cart.shipping.country}
              </div>
            </div>
          ) : (
            <div className="box-shadow">
              <h3>Ophaal Adres</h3>
              <div>Suriname, Paramaribo, Doebestraat #3, Welgelegen</div>
            </div>
          )}
          <div className="box-shadow">
            <h3>Betaling</h3>
            <div>Betalings Methode: {cart.payment.paymentMethod}</div>
          </div>
          <div className="box-shadow">
            {pickUp === true ? (
            <h3>Ophaal Datum, Tijd & Notes</h3>
            ):(
              <h3>Leverings Datum, Tijd & Notes</h3>
            )}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div>
                <KeyboardDatePicker
                  disableToolbar
                  variant="dialog"
                  format="MM/dd/yyy"
                  margin="normal"
                  id="date-picker"
                  label="Datum"
                  value={date}
                  onChange={handleDate}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                />
              </div>

              <div>
                <KeyboardTimePicker
                  margin="normal"
                  id="time-picker"
                  label="Tijd"
                  value={date}
                  onChange={handleDate}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                />
              </div>
            </MuiPickersUtilsProvider>
            <div>
              <TextField
                id="outlined-multiline-static"
                placeholder="Notes..."
                multiline
                rows={4}
                variant="outlined"
                className={classes.area}
                onChange={e => setNotes(e.target.value)}
              />
            </div>
          </div>
          <div className="box-shadow">
            <ul className="cart-list-container">
              <li>
                <h3>Shopping Cart</h3>
                <div>Price</div>
              </li>
              {cartItems.length === 0 ? (
                <div>Cart is empty</div>
              ) : (
                cartItems.map(item => (
                  <li>
                    <div className="cart-image">
                      <img src={item.image} alt="product" />
                    </div>
                    <div className="cart-name">
                      <div>
                        <Link to={"/product/" + item.product}>{item.name}</Link>
                      </div>
                      <InputLabel
                        className={classes.quantity}
                        id="demo-controlled-open-select-label"
                      >
                        Quantity: {item.qty}
                      </InputLabel>
                    </div>
                    <div className="cart-price">€ {item.price.toFixed(2)}</div>
                  </li>
                ))
              )}
            </ul>
          </div>
        </div>
        <div className="placeorder-action ">
          <ul>
            <li>
              <ReactSwipeButton
                text_unlocked="BESTELD"
                text="Plaats Bestelling"
                color="#3f51b5"
                onSuccess={placeOrderHandler}
              />
            </li>
            <li>
              <h3>Order Summary</h3>
            </li>
            <li>
              <div>Items</div>
              <div>€ {itemPrice}</div>
            </li>
            <li>
              {shippingPrice !== 0 && (
                <>
                  <div>Shipping</div>
                  <div>€ {shippingPrice}</div>
                </>
              )}
            </li>
            <li>
              <div>Korting</div>
              <div>€ {'0'}</div>
            </li>
            <li>
              <div>Order Total</div>
              <div>€ {totalPrice}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PlaceOrderScreen;
